import React from 'react'
import { Layout, Menu } from 'antd'
import { useNavigate } from 'react-router-dom'
import SubMenu from 'antd/lib/menu/SubMenu';

const { Content, Sider } = Layout
const menuList = [
    {
        key: "/content/start",
        title: "快速入门",
        children: []
    },
 /*   {
        key: "/content/widget",
        title: "软件界面",
        children: []
    },
*/    {
        key: "/content/model",
        title: "绿化一览",
        children: [
            {
                key: "/content/model/qiaomu",
                title: "乔木",
                children: []
            },
            {
                key: "/content/model/guanmu",
                title: "灌木",
                children: []
            },
            {
                key: "/content/model/model",
                title: "3D模型",
                children: []
            }
        ]
    },
    {
        key: "/content/contact",
        title: "联系我们",
        children: []
    },
/*    {
        key: "/content/roadtex",
        title: "道路材质",
        children: []
    },
    {
        key: "/content/landscape",
        title: "景观布置",
        children: [
            {
                key: "/content/landscape/add",
                title: "布置景观",
                children: []
            },
            {
                key: "/content/landscape/operate",
                title: "修改景观",
                children: []
            }
        ]
    },
    {
        key: "/content/envir",
        title: "周边环境",
        children: [
            {
                key: "/content/envir/weather",
                title: "天气",
                children: []
            },
            {
                key: "/content/envir/terr",
                title: "地形",
                children: []
            },
            {
                key: "/content/envir/light",
                title: "灯光",
                children: []
            },
            {
                key: "/content/envir/effec",
                title: "后效",
                children: []
            }
        ]
    }
*/]

export default function SideMenu() {
    const navigate = useNavigate();
    const renderMenu = (menuList) => {
        return menuList.map(item => {
            if (item.children.length > 0) {
                return <SubMenu key={item.key} title={item.title}>
                    {renderMenu(item.children)}
                </SubMenu>
            }
            return <Menu.Item key={item.key} onClick={() => {
                navigate(item.key)
            }}>
                {item.title}
            </Menu.Item>
        })
    }
    return (
 //       <Layout>
            <Content style={{
                overflow: 'auto',
                height: '100vh',
                width: 200,
                position: 'fixed',
                left: 0,
                top: 0,
                bottom: 0,
                paddingTop:65,
              }}>
                <Menu
                    mode="inline"
                    defaultSelectedKeys={['1']}
                    defaultOpenKeys={['sub1']}
                    style={{ height: '100%' }}
                >
                    {renderMenu(menuList)}
                </Menu>
            </Content>
//        </Layout>
    )
}
